<template>
  <div class="mainfooter _mainfooter">
    <div class="footerbottom _footerbottom">
        <div class="scroll_top" @click="backtop">返回顶部</div>
        <p>@聚利和 版权所有2009-2021  京ICP备12009157号-1 </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'mainfooter',
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    backtop () {
      let back = setInterval(() => {
        if (document.body.scrollTop || document.documentElement.scrollTop) {
          document.body.scrollTop -= 10
          document.documentElement.scrollTop -= 50
        } else {
          clearInterval(back)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
    ._mainfooter{
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: start;
        ._footerbody{
            width: 100%;
            display: flex;
            justify-content: space-around;
            text-align: left;
            // padding: 20px 0;
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            // height: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            // margin:0 10%;
            div{
                margin: 0 10px;
                width: 95%;
                h1{
                    display: block;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                    color: rgba(0, 0, 0, 0.5);
                    height: 40px;
                    font-size: 10px;
                    font-weight:800;
                    line-height: 40px;
                    // margin: 7px 0;
                }
                p{
                    display: none ;
                    font-size: 10px;
                    margin: 7px 0;
                }
            }
        }
        ._footerbottom{
            padding: 4vh 0;
            background:rgba(2, 119, 199, 1);
            padding-top:2vh;
            .scroll_top{
              font-size:0.8rem;
              padding:37px 0px 2vh 0px;
              background: url('/static/img/scrolltop.png') no-repeat center top;
              background-size: 40px;
              color:#fff;
              font-weight: bold;
              letter-spacing: 1px;
            }
            p{
                font-size: 0.6rem;
                color:#fff;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/comcomponents/Footer.vue